import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ShopProvider } from "@/context/ShopContext";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import Wholesale from "@/pages/Wholesale";
import DenimReview from "@/pages/DenimReview";

function App() {
  return (
    <div className="App">
      <ShopProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/wholesale" element={<Wholesale />} />
              <Route path="/denim-review" element={<DenimReview />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/:collection" element={<Shop />} />
              <Route path="/product/:id" element={<ProductDetail />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </ShopProvider>
    </div>
  );
}

export default App;
